import LoadingRow from '../LoadingRow';
import styles from './LoadingQuestion.module.scss';

interface LoadingQuestionProps {
  questionType?:
    | 'radio'
    | 'checkbox'
    | 'rating'
    | 'text'
    | 'statement'
    | 'matching'
    | 'ai_tutor';
}

function LoadingQuestion({questionType}: LoadingQuestionProps): JSX.Element {
  return (
    <div className={styles.wrapper}>
      <LoadingRow width="8rem" />

      <div className={styles.descriptionSkeleton}>
        <LoadingRow width="90%" height="1rem" />
        <LoadingRow width="70%" height="1rem" />
        <LoadingRow width="80%" height="1rem" />
        <LoadingRow width="50%" height="1rem" />
      </div>

      {(questionType === 'radio' || questionType === 'checkbox') && (
        <div className={styles.checkboxSkeleton}>
          <LoadingRow width="90%" height="4rem" />
          <LoadingRow width="90%" height="4rem" />
          <LoadingRow width="90%" height="4rem" />
        </div>
      )}

      {questionType === 'text' && <LoadingRow width="100%" height="6rem" />}

      {questionType === 'rating' && (
        <div className={styles.ratingSkeleton}>
          <LoadingRow width="70%" height="5rem" />
        </div>
      )}

      <div className={styles.buttonsSkeleton}>
        <LoadingRow width="6rem" height="2.5rem" />
        <LoadingRow width="6rem" height="2.5rem" />
      </div>
    </div>
  );
}

export default LoadingQuestion;
